import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import moment from 'moment';

import { StyledtBlocWrapper } from 'containers/AutoDetailsPage/SuivreSinistreTab/styles';
import AccordionSinistre from 'components/AccordionSinistre';
import { ShortBody } from 'components/Typography';
import messages from 'containers/AutoDetailsPage/SuivreSinistreTab/Sinistres/messages';
import { StyledDiv } from 'containers/AutoDetailsPage/SuivreSinistreTab/Sinistres/styles';
import { translate } from 'helpers/intl';

const SuivreSinitre = ({
  getSinistreDetails,
  isLoading,
  ...props
}: {
  intl: IntlShape;
  getSinistreDetails: Function;
  sinistreDetails: {
    title: string;
    subtitle: string;
    actualDate: any;
    timelineState: string;
    shareName: string;
    status: string;
    description: string;
  }[];
  sinistres: {
    claimNumber: string;
    claimLossDate: string;
    lastUpdateDate: string;
    vehicleReg: string;
    marque: string;
    claimStatus: string;
    claimYear: string;
  }[][];
  isLoading: boolean;
}) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [claimNumber, setClaimNumber] = useState<String>('');
  const handleChange = (index: String, claimNumber: String) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    if (isExpanded) setClaimNumber(claimNumber);
    /* istanbul ignore next */
    setExpanded(isExpanded ? index : false);
  };

  useEffect(() => {
    getSinistreDetails(claimNumber);
  }, [getSinistreDetails, claimNumber]);
  return (
    <StyledtBlocWrapper height="auto">
      {Object.keys(props.sinistres)
        .map((list: any) => (
          <>
            <StyledDiv>
              <ShortBody color={'#838EA4'}>
                {moment().get('year') ===
                parseInt(props.sinistres[list][0].claimYear)
                  ? translate(get(messages, 'currentYear'), props)
                  : translate(get(messages, 'year'), props) +
                    '' +
                    props.sinistres[list][0].claimYear}
              </ShortBody>
            </StyledDiv>

            <AccordionSinistre
              listIndex={list}
              isLoading={isLoading}
              sinistres={props.sinistres[list]}
              getSinistreDetails={getSinistreDetails}
              sinistreDetails={props.sinistreDetails}
              expanded={expandeds}
              handleChange={(index: String, claimNumber: String) =>
                handleChange(index, claimNumber)
              }
            />
          </>
        ))
        .reverse()}
    </StyledtBlocWrapper>
  );
};
export default injectIntl(SuivreSinitre);
